import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  UpdateCurrentCompanyAddressDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { AxiosResponse } from "axios";

import { DOMAIN_COMPANIES } from "../domain";
import { ACTION_GET_CURRENT_COMPANY_SETTINGS } from "../GetCurrentCompanySettings";

import { companiesApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_CURRENT_COMPANY_SETTINGS =
  "UPDATE_CURRENT_COMPANY_SETTINGS";

const allowedRoles = [UserRole.Owner];

const updateCurrentCompanyAddress = async (
  data: UpdateCurrentCompanyAddressDto,
): Promise<AxiosResponse<void>> => {
  const response =
    await companiesApi.companiesControllerUpdateCurrentCompanyAddress(data);

  return response;
};

export const useUpdateCurrentCompanyAddress = (
  user: UserProfileDto | null,
): {
  updateCurrentCompanyAddress: (data: UpdateCurrentCompanyAddressDto) => void;
  updateCurrentCompanyAddressAsync: (
    data: UpdateCurrentCompanyAddressDto,
  ) => Promise<AxiosResponse<void>>;
  updateCurrentCompanyAddressEnabled: boolean;
  isSuccessUpdateCurrentCompanyAddress: boolean;
  isPendingUpdateCurrentCompanyAddress: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_COMPANIES, ACTION_UPDATE_CURRENT_COMPANY_SETTINGS],
    mutationFn: enabled ? updateCurrentCompanyAddress : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_SETTINGS],
      });
    },
  });

  return {
    updateCurrentCompanyAddress: mutate,
    updateCurrentCompanyAddressEnabled: enabled,
    updateCurrentCompanyAddressAsync: mutateAsync,
    isSuccessUpdateCurrentCompanyAddress: isSuccess,
    isPendingUpdateCurrentCompanyAddress: isPending,
  };
};
